import script from "./electronic-components-record.vue?vue&type=script&lang=ts&setup=true"
export * from "./electronic-components-record.vue?vue&type=script&lang=ts&setup=true"

import "./electronic-components-record.vue?vue&type=style&index=0&id=ad883d86&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad883d86"]])

export default __exports__